import React, { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import AppBanner from '../common/AppBanner';
import BetaSiteBanner from '../common/BetaSiteBanner';
import { GROUPS, HOME_GROUPS } from '../../config/groups';

const HomePage = () => {
  document.title = '坂道Message';

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const error = searchParams.get('error');

    if (error) {
      // 顯示錯誤訊息
      let message = '登入失敗，請重試';

      switch (error) {
        case 'state_mismatch':
          message = '登入驗證失敗（CSRF），請重新登入';
          break;
        case 'auth_failed':
          message = '認證失敗，請確認帳號權限';
          break;
        case 'access_denied':
          message = '您拒絕了授權請求';
          break;
        default:
          message = `登入錯誤：${error}`;
      }

      setErrorMessage(message);

      // 清除 URL 參數
      navigate('/', { replace: true });

      // 5 秒後自動清除錯誤訊息
      setTimeout(() => {
        setErrorMessage(null);
      }, 5000);
    }
  }, [searchParams, navigate]);

  return (
    <div className="w-100 d-flex justify-content-center">
      <Container style={{ maxWidth: '1000px' }}>
        <BetaSiteBanner />
        <AppBanner />

        {/* 顯示錯誤訊息 */}
        {errorMessage && (
          <Alert
            variant="danger"
            dismissible
            onClose={() => setErrorMessage(null)}
            className="mt-3"
          >
            <Alert.Heading>登入失敗</Alert.Heading>
            <p>{errorMessage}</p>
          </Alert>
        )}

        <Row className="justify-content-center g-4 mt-3">
          {/* 增加了 g-4 類添加間距，mt-3 增加上邊距 */}
          {HOME_GROUPS.map((code) => {
            const group = GROUPS[code];
            return (
              <Col key={code} xs={12} sm={6} md={4} className="text-center">
                <Link to={`/groups/${code}`} className="text-decoration-none">
                  <div className="card mx-auto shadow-sm">
                    <div className="p-3">
                      <img
                        src={group.image}
                        className="card-img-top home-group-logo"
                        alt={group.name}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.style.visibility = 'hidden';
                        }}
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">{group.name}</h5>
                    </div>
                  </div>
                </Link>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};

export default HomePage;
